import React from "react";
import { IPagination, UtcTimePopover } from "../screenshots/screenshots.component";
import LoadingService from "../../components/loading-indicator/loading-indicator.service";
import { ShowErrorFromResponse } from "../../utilities/response-processor";
import { getFeedbacksClient, getQuestionaresClient, getUserTagsClient } from "../../services/api-clients.service";
import SubHeader from "../../layout/components/sub-header/sub-header.component";
import ContentWrapper from "../../layout/components/content-wrapper/content-wrapper.component";
import { Card, Dropdown, Form, OverlayTrigger } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import { addDays } from "../../utilities/date.utilities";
import { DateTimeDisplayUTC } from "../../components/date-time-display/date-time-display-utc.component";
import { FeedbackResponseModel, LogicalOperator, NpsCategory, QuestionaireResponseModel, UserTagResponseModel, UserType } from "../../swagger-clients/s365-admin-panel-clients.service";
import BootstrapTooltip from "../../components/bootstrap-tooltip/bootstrap-tooltip";
import { UserSlimDisplay } from "../../components/user-slim-display/user-slim-display";
import { ReactSelectOption } from "../users/user-activity-level-select/user-activity-level-select.component";
import SystemUserTagCodes from "../users/users.shared";
import { _copyAndSort } from "../../utilities/array.helpers";
import { UserTagFilter } from "../../components/user-tag-filter/user-tag-filter.component";
import Select from "react-select";
type LoginQuestionairePageProps = {

}

const getTodayDate = () => {
    let dateNow = new Date();
    dateNow.setHours(0);
    dateNow.setMinutes(0);
    dateNow.setSeconds(0);
    dateNow.setMilliseconds(0);
    return dateNow;
}

const getDefaultStartDate = () => {

    return addDays(getTodayDate(), -30);
}


const getDefaultEndDate = () => {
    let tomorrow = addDays(new Date(), 1);
    tomorrow.setHours(0);
    tomorrow.setMinutes(0);
    tomorrow.setSeconds(0);
    tomorrow.setMilliseconds(0);
    return tomorrow;

}

const signupReasonOptions: ReactSelectOption[] = [
    {
        label: "To compare prices", value: "signupReason_comparePrices"
    },
    {
        label: "I have a simulation task", value: "signupReason_simulationTask"
    },
    {
        label: "DWSIM Pro seems better than DWSIM", value: "signupReason_betterThanFree"
    },
    {
        label: "I am looking for an alternative to a commercial simulator", value: "signupReason_alternative"
    }
];

const howYouWorkOnFlowsheetsOptions: ReactSelectOption[] = [
    {
        label: "I work alone on simulation projects", value: "howYouWorkOnFlowsheets_alone"
    },
    {
        label: "I work as part of a small team (2-5 people)", value: "howYouWorkOnFlowsheets_smallTeam"
    },
    {
        label: "I'm in a larger team (6+ simulation experts)", value: "howYouWorkOnFlowsheets_largeTeam"
    },
    {
        label: "I collaborate with external partners", value: "howYouWorkOnFlowsheets_external"
    }
];

const usedDwsimFreeOptions: ReactSelectOption[] = [
    {
        label: "Yes", value: "usedDwsimFree_yes"
    },
    {
        label: "No", value: "usedDwsimFree_no"
    }
];
const protectPropertyOptions: ReactSelectOption[] = [
    {
        label: "No", value: "protectProperty_No"
    },
    {
        label: "I am concerned about protecting my flowsheet's intellectual property.", value: "protectProperty_Concerned"
    },
    {
        label: "My IT department deals with this, e.g., CLOUD Act.", value: "protectProperty_IT_department"
    },
    {
        label: "My company is not concerned about protecting my flowsheet's intellectual property. ", value: "protectProperty_not_concerned"
    }
];


export const LoginQuestionairePage: React.FC<LoginQuestionairePageProps> = (props) => {

    const [asnwers, setAnswers] = React.useState<QuestionaireResponseModel[]>([]);
    const [pagination, setPagination] = React.useState<IPagination>({
        currentPage: 1,
        recordsPerPage: 20,
        totalRecords: 0
    });
    const [fromDate, setFromDate] = React.useState<Date>(getDefaultStartDate());
    const [toDate, setToDate] = React.useState<Date>(getDefaultEndDate());
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [searchTerm, setSearchTerm] = React.useState<string>();
    const [includeUserTags, setIncludeUsersTags] = React.useState<number[]>([]);
    const [includeOperator, setIncludeOperator] = React.useState<LogicalOperator>(LogicalOperator.And);
    const [excludeUserTags, setExcludeUsersTags] = React.useState<number[]>([]);
    const [excludeOperator, setExcludeOperator] = React.useState<LogicalOperator>(LogicalOperator.Or);
    const [defaultUserTagsSet, setDefaultUserTagsSet] = React.useState<boolean>(false);
    const [signupReason, setSignupReason] = React.useState<string>();
    const [usedDwsimFree, setUsedDwsimFree] = React.useState<string>();
    const [dwsimRate, setDwsimRate] = React.useState<number>();
    const [protectProperty, setProtectProperty] = React.useState<string>();
    const [howYouWorkOnFlowsheets, setHowyouWorkOnFlowsheets] = React.useState<string>();
    const [orderBy, setOrderBy] = React.useState<string>("createdAtUtc");
    const [orderByDescending, setOrderByDescending] = React.useState<boolean>(true);


    React.useEffect(() => {
        setDefaultUserTags();
    }, []);
    React.useEffect(() => {
        if (defaultUserTagsSet) {
            getAnswers();
        }
    }, [pagination.currentPage, pagination.recordsPerPage, defaultUserTagsSet, orderBy, orderByDescending]);

    const setDefaultUserTags = async () => {
        const allUserTags = await getAllUserTags();
        const testUserTag = allUserTags.find(x => x.code == SystemUserTagCodes.TEST_USER);
        let includeTags: number[] = [];
        const companyUserTag = allUserTags.find(x => x.code == SystemUserTagCodes.COMPANY);
        if (!!companyUserTag) {
            includeTags.push(companyUserTag.id);
        }
        let excludeTags: number[] = !!testUserTag ? [testUserTag.id] : [];
        const consumerUserTag = allUserTags.find(x => x.code == SystemUserTagCodes.CONSUMER);
        if (!!consumerUserTag) {
            excludeTags.push(consumerUserTag.id);
        }
        setIncludeUsersTags(includeTags);
        setExcludeUsersTags(excludeTags);
        setDefaultUserTagsSet(true);
    }

    const getAllUserTags = async () => {
        try {
            const client = getUserTagsClient();
            const userTagsResp = await client.getUserTags(null, null, undefined, 0, 10000);
            const sortedMappedOptions = _copyAndSort<UserTagResponseModel>(userTagsResp.items, "name", false);
            return sortedMappedOptions;

        } catch (error) {
            console.log("An error occurred while loading user tags", error);
        }

    }

    const getAnswers = async () => {
        try {
            setAnswers([]);
            setIsLoading(true);

            const { recordsPerPage, currentPage } = pagination;
            const client = getQuestionaresClient();
            const startDateUtc = fromDate ? new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds())) : null;
            const endDateUtc = toDate ? new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes(), toDate.getSeconds())) : undefined;
            const answersResponse = await client.getLoginQuestionareAnswers(searchTerm, signupReason, howYouWorkOnFlowsheets, usedDwsimFree, dwsimRate, protectProperty, startDateUtc, endDateUtc,
                includeUserTags, includeOperator, excludeUserTags, excludeOperator, orderBy, orderByDescending, (currentPage - 1) * recordsPerPage, recordsPerPage);
            setAnswers(answersResponse?.items ?? []);
            setPagination(s => ({ ...s, totalRecords: answersResponse?.totalRecords ?? 0 }));


        } catch (error) {
            ShowErrorFromResponse(error, "An error ocurred while getting questionaire answers.");
        } finally {
            setIsLoading(false);
        }
    }


    const onTodayClick = () => {
        setFromDate(getTodayDate());
        setToDate(getDefaultEndDate());

    }
    const onLast7DaysClick = () => {
        const startDate = addDays(getTodayDate(), -7);
        setFromDate(startDate);
        setToDate(getDefaultEndDate());

    }
    const onLast30DaysClick = () => {
        const startDate = addDays(getTodayDate(), -30);
        setFromDate(startDate);
        setToDate(getDefaultEndDate());

    }

    const onLastMonthClick = () => {
        const dateNow = new Date();
        const firstInMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1, 0, 0, 0);
        let firstInNextMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1, 0, 0, 0);
        firstInNextMonth.setMonth(firstInMonth.getMonth() + 1);
        const lastDayOfMonth = addDays(firstInNextMonth, -1);
        setFromDate(firstInMonth);
        setToDate(lastDayOfMonth);

    }

    const onLastYearClick = () => {
        const dateNow = new Date();
        const januaryFirst = new Date(dateNow.getFullYear(), 0, 1, 0, 0, 0);
        setFromDate(januaryFirst);
        setToDate(getDefaultEndDate());

    }

    const onAddDayClick = (numberOfDays: number) => {

        const newDate = addDays(fromDate ?? new Date(), numberOfDays);
        setFromDate(newDate);
    }
    const onAddMonthClick = (numberOfMonths: number) => {
        let newDate = !!fromDate ? new Date(fromDate) : new Date();
        newDate.setMonth(newDate.getMonth() + numberOfMonths);
        setFromDate(newDate);
    }

    const onColumnClick = (column: string) => {

        if (orderBy == column) {
            setOrderByDescending(!orderByDescending);
        } else {
            setOrderBy(column);
            setOrderByDescending(true);
        }
    }

    const getSortValue = (columnName: string) => {

        if (orderBy == columnName) {
            if (orderByDescending) {
                return "desc";
            } else {
                return "asc";
            }
        }
        return "";
    }

    const selectedSignupReason = signupReason !== undefined ? signupReasonOptions.find(x => x.value! == signupReason) : undefined;
    const selectedHowYouWorkOnFlowsheets = howYouWorkOnFlowsheets !== undefined ? howYouWorkOnFlowsheetsOptions.find(x => x.value! == howYouWorkOnFlowsheets) : undefined;
    const selectedProtectProperty = protectProperty !== undefined ? protectPropertyOptions.find(x => x.value! == protectProperty) : undefined;
    const { totalRecords, currentPage, recordsPerPage } = pagination;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    return <div> <SubHeader key="sub-header" title="Login questionaire" leftItems={[]} rightItems={[]} />
        <ContentWrapper key="content-wrapper" className="pl-4 pr-4">
            <Card className='mb-4' style={{ marginRight: "auto", marginLeft: "auto", width: "100%" }}>
                <div className="pt-3 pl-3 pr-3 mr-3 d-flex justify-content-between">
                    <form onSubmit={(ev) => { ev.preventDefault(); if (currentPage !== 1) { setPagination(s => ({ ...s, currentPage: 1 })); } else { getAnswers(); } }} action="">
                        <div className="d-flex flex-column">
                            <div className="form-row align-items-center">
                                <div className="col-2 input-group mr-2 mb-2" style={{ minWidth: "350px" }}>
                                    <span className="input-group-text"><i className="far fa-user"></i></span>
                                    <input type="text"
                                        name="searchTerm"
                                        className="form-control"
                                        onChange={(ev) => { const value = ev.target.value.toString(); setSearchTerm(value); }}
                                        placeholder="Display name or User principal name or Email" value={searchTerm}
                                    />
                                </div>

                                <div className="input-group mr-2 mb-2" style={{ width: '380px' }}>
                                    <span className="input-group-text"><i className="far fa-calendar-alt"></i></span>
                                    <div className="input-group__datepicker-wrapper">
                                        <DatePicker
                                            id="fromDate"
                                            className="form-control"
                                            selected={fromDate}
                                            onChange={(date: Date) => {
                                                if (!date) {
                                                    setFromDate(getDefaultStartDate());
                                                } else
                                                    setFromDate(new Date(Date.parse(date != null ? date.toString() : "")));
                                            }}
                                            showTimeSelect
                                            maxDate={toDate}
                                            dateFormat="dd-MM-yyyy HH:mm"
                                            timeFormat="HH:mm" />
                                    </div>
                                    <span className="input-group-text">-</span>

                                    <div className="input-group__datepicker-wrapper">
                                        <DatePicker
                                            id="toDate"
                                            className="form-control"
                                            selected={toDate}
                                            onChange={(date: Date) => {
                                                if (!date) {
                                                    setToDate(getDefaultEndDate());
                                                } else
                                                    setToDate(new Date(Date.parse(date != null ? date.toString() : "")))
                                            }}
                                            showTimeSelect
                                            maxDate={new Date()}
                                            dateFormat="dd-MM-yyyy HH:mm"
                                            timeFormat="HH:mm" />
                                    </div>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary" className="datePickerWithDropdown" id="dropdown-basic" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={onTodayClick} >Today</Dropdown.Item>
                                            <Dropdown.Item onClick={onLast7DaysClick}>Last 7 days</Dropdown.Item>
                                            <Dropdown.Item onClick={onLast30DaysClick}>Last 30 days</Dropdown.Item>
                                            <Dropdown.Item onClick={onLastMonthClick}>This month</Dropdown.Item>
                                            <Dropdown.Item onClick={onLastYearClick}>This year</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { onAddDayClick(1) }}>+ day</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { onAddDayClick(-1) }}>- day</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { onAddMonthClick(1) }}>+ month</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { onAddMonthClick(-1) }}>- month</Dropdown.Item>

                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className="col-auto mr-2 mb-2" style={{ minWidth: "250px" }}>
                                    <Select
                                        value={selectedSignupReason}
                                        placeholder={"Signup reason"}
                                        isClearable
                                        options={signupReasonOptions}
                                        onChange={(newValue) => {
                                            setSignupReason(newValue?.value?.toString());
                                        }}
                                    />
                                </div>
                                <div className="col-auto mr-2 mb-2" style={{ minWidth: "250px" }}>
                                    <Select
                                        value={selectedHowYouWorkOnFlowsheets}
                                        placeholder={"How you work"}
                                        isClearable
                                        options={howYouWorkOnFlowsheetsOptions}
                                        onChange={(newValue) => {
                                            setHowyouWorkOnFlowsheets(newValue?.value?.toString());
                                        }}
                                    />
                                </div>
                                <div className="col-auto mr-2 mb-2">
                                    <Select
                                        value={selectedSignupReason}
                                        placeholder={"Used DWSIM"}
                                        isClearable
                                        options={usedDwsimFreeOptions}
                                        onChange={(newValue) => {
                                            setUsedDwsimFree(newValue?.value?.toString());
                                        }}
                                    />
                                </div>
                                <div className="col-2 input-group mr-2 mb-2" style={{ maxWidth: "160px" }}>
                                    <input
                                        type="number"
                                        min="1"
                                        max="5"
                                        step="1"
                                        name="dwsimRate"
                                        value={dwsimRate ?? ""}
                                        className="form-control"
                                        onChange={(ev) => {
                                            const raw = ev.target.value;

                                            if (raw === "") {
                                                setDwsimRate(undefined);
                                                return;
                                            }

                                            const num = Number(raw);

                                            if (!Number.isInteger(num) || num < 1 || num > 5) {
                                                return;
                                            }

                                            setDwsimRate(num);
                                        }}
                                        placeholder="DWSIM rate (1-5)"
                                    />
                                </div>
                                <div className="col-auto mr-2 mb-2" style={{ minWidth: "250px" }}>
                                    <Select
                                        value={selectedProtectProperty}
                                        placeholder={"Work under NDA"}
                                        isClearable
                                        options={protectPropertyOptions}
                                        onChange={(newValue) => {
                                            setProtectProperty(newValue?.value?.toString());
                                        }}
                                    />
                                </div>

                                <div className="col-auto pr-2" style={{ minWidth: "400px" }}>
                                    <UserTagFilter
                                        icon="fas fa-check"
                                        iconColor="green"
                                        logicalOperator={includeOperator}
                                        values={includeUserTags}
                                        className="mb-2"
                                        placeholder={"Include tags"}
                                        onOperatorChange={(operator) => { setIncludeOperator(operator); }}
                                        onChange={(newValues) => {
                                            const values: number[] | undefined = newValues !== undefined && newValues !== null ? newValues.map(x => +x.value) : undefined;
                                            setIncludeUsersTags(values);
                                        }}
                                    />
                                </div>
                                <div className="col-auto pl-0 pr-2" style={{ minWidth: "400px" }}>
                                    <UserTagFilter
                                        icon="fas fa-times"
                                        iconColor="red"
                                        logicalOperator={excludeOperator}
                                        values={excludeUserTags}
                                        className="mb-2"
                                        placeholder={"Exclude tags"}
                                        onOperatorChange={(operator) => { setExcludeOperator(operator); }}
                                        onChange={(newValues) => {
                                            const values: number[] | undefined = newValues !== undefined && newValues !== null ? newValues.map(x => +x.value) : undefined;
                                            setExcludeUsersTags(values);
                                        }}
                                    />
                                </div>
                                <div className="col-auto ml-2">
                                    <button type="submit" className="btn btn-primary mb-2" >Search</button></div>
                            </div>




                        </div>

                    </form>
                    <div className="mr-3"
                        style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: "flex-start",
                            textAlign: "center",
                            gap: "2px"
                        }}>
                        <b style={{ fontSize: '1.5em', lineHeight: '1em' }}>{totalRecords}</b>
                        <span style={{ fontSize: '0.8em', lineHeight: '0.8em' }}>Total records</span>
                    </div>
                    <div style={{ width: "130px" }}>
                        <select className="form-control form-select" value={recordsPerPage} onChange={(event) => setPagination(s => ({ ...s, recordsPerPage: +event.target.value }))}>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>

                        </select>
                    </div>

                </div>
            </Card>
            <Card >
                <Card.Body>

                    <div className="">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className="">User</th>
                                    <th className=" text-center">What brings you here?</th>
                                    <th className={"sortable " + getSortValue("usedDwsimFree")}
                                        onClick={() => { onColumnClick("usedDwsimFree") }}>Have you used DWSIM open source?</th>
                                    <th className={"sortable " + getSortValue("dwsimFreeRank")} style={{ maxWidth: "150px" }}
                                        onClick={() => { onColumnClick("dwsimFreeRank") }}>How would you rate DWSIM Free?</th>
                                    <th className=" text-center">How do you typically work with flowsheets?</th>
                                    <th className=" text-center">Do you work under Non-Disclosure Agreement (NDA)?</th>
                                    <th className={"sortable " + getSortValue("createdAtUtc")}
                                        onClick={() => { onColumnClick("createdAtUtc") }}>Created at</th>
                                </tr>
                            </thead>
                            <tbody>

                                {asnwers.map((item) =>
                                (<tr key={item.userId} >
                                    <td className="">
                                        {!!item.user && <UserSlimDisplay user={item.user} showDetailsOnClick />}
                                    </td>
                                    <td className="align-middle text-center" >{item.questions.find(x => x.questionCode == "signup_reason")?.answer ?? "-"}</td>
                                    <td className="align-middle text-center" >{item.questions.find(x => x.questionCode == "usedDwsimFree")?.answer ?? "-"}</td>
                                    <td className="align-middle text-center" >{(() => {
                                        const answer = item.questions.find(x => x.questionCode === "dwsimFreeRank")?.answer;
                                        return answer ? `${answer}/5` : "-";
                                    })()}</td>
                                    <td className="align-middle text-center" >{item.questions.find(x => x.questionCode == "howYouWorkOnFlowsheets")?.answer ?? "-"}</td>
                                    <td className="align-middle text-center" >{item.questions.find(x => x.questionCode == "protectProperty")?.answer ?? "-"}</td>

                                    <td className="align-middle text-center">
                                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={UtcTimePopover}>
                                            <span><DateTimeDisplayUTC date={item.createdAtUtc!} /></span>
                                        </OverlayTrigger></td>

                                </tr>))
                                }

                                {!!isLoading &&
                                    <tr>
                                        <td colSpan={5} className="text-center">Loading...</td>
                                    </tr>
                                }


                            </tbody>
                        </table>

                        {totalPages > 1 &&
                            <div className="d-flex align-items-center">
                                <ReactPaginate
                                    previousLabel={'previous'}
                                    nextLabel={'next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    pageCount={totalPages}
                                    marginPagesDisplayed={4}
                                    pageRangeDisplayed={10}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    forcePage={currentPage - 1}
                                    onPageChange={(page: any) => {
                                        console.log("Selected page:", page);
                                        setPagination(s => ({ ...s, currentPage: page.selected + 1 }));
                                        document.body.scrollTop = 0; // For Safari
                                        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                                    }}
                                    containerClassName={'pagination mb-0'}
                                    activeClassName={'active'}
                                />

                            </div>
                        }
                    </div>



                </Card.Body>
            </Card>
        </ContentWrapper></div>;
}